import { render, staticRenderFns } from "./OpportunityDashboardLossReasonsChart.vue?vue&type=template&id=b9633a4a&scoped=true&"
import script from "./OpportunityDashboardLossReasonsChart.vue?vue&type=script&lang=js&"
export * from "./OpportunityDashboardLossReasonsChart.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDashboardLossReasonsChart.vue?vue&type=style&index=0&id=b9633a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9633a4a",
  null
  
)

export default component.exports